import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import './Concepto.scss'; // Asegúrate de actualizar tus estilos
import { useTranslation } from 'react-i18next';

const Concepto = (props) => {
  const { children, titulo1, titulo2 } = props;
  const { t } = useTranslation();

  const handleVideo = () => {
    props.setVideo(true);
    props.setUrlVideo("U1pR-yp3ajY");
  };

  return (
    <div id="concepto" className='contenedor_video'> {/* Usando la clase contenedora del primer diseño */}
      
      {/* COLUMNA IZQUIERDA: Textos */}
      <div className='contenedor_video__left'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='contenedor_video__left_subtitulo'>
            <h2>{titulo1} <br /> {titulo2}</h2>
          </div>
        </AnimationOnScroll>

        <div className='contenedor_video__left_texto'>
          {children}
        </div>

        <div className='contenedor_video__left_button'>
          <a href='/#masterplan'>{t('concepto.availability')}</a>
        </div>
      </div>

      {/* COLUMNA DERECHA: Carrusel de Videos */}
      <div className='contenedor_video__right'>
        <img
          className='play'
          src="/assets/Logos/boton-de-play.png"
          alt={t('conceptoVideo.playButtonAlt')}
          onClick={() => handleVideo()}
        />
        <div className='contenedor_video__right_video'>
          <video src="/assets/Video/loopprincipal.mp4" autoPlay muted loop></video>
        </div>
      </div>

    </div>
  );
};

export default Concepto;